$(window).load(function () {
  var pic1 = new Image();
  var pic2 = new Image();
  var pic3 = new Image();
  var pic4 = new Image();
  var pic5 = new Image();
  var pic6 = new Image();
  pic1.src =
    'https://d35408cyocioye.cloudfront.net/new3/vail/palladiom-white@.jpg';
  pic2.src =
    'https://d35408cyocioye.cloudfront.net/new3/vail/palladiom-black@.jpg';
  pic3.src =
    'https://d35408cyocioye.cloudfront.net/new3/vail/palladiom-satin-nickel@.jpg';
  pic4.src =
    'https://d35408cyocioye.cloudfront.net/new3/vail/palladiom-polished-graphite@.jpg';
  pic5.src =
    'https://d35408cyocioye.cloudfront.net/new3/vail/claro-snow-white@.jpg';
  pic6.src =
    'https://d35408cyocioye.cloudfront.net/new3/vail/claro-midnight@.jpg';

  let imgs = [pic1, pic2, pic3, pic4, pic5, pic6];
  // $('.hp-ai').addClass('img-01');
  // $('.hp-ai').addClass('img-02');
  // $('.hp-ai').addClass('img-03');
  // $('.hp-ai').addClass('img-04');
  // $('.hp-ai').addClass('img-05');
  // $('.hp-ai').addClass('img-06');
  // DISABLE SCROLLING
  $('html').css('overflow', 'hidden');
  setTimeout(function () {
    // $('.hp-ai').removeClass('img-02 img-01 img-04 img-05 img-06');
    $('html').css('overflow', 'unset');
    $('.hp-landTextContainer').css('opacity', '1');
  }, 300);

  //INITIAL
  const videoId = 'HzjrINKDoho';
  const youtubeVideoSrc = `https://www.youtube.com/embed/${videoId}?enablejsapi=1`;
  $('#keynote-video-embed').attr('src', youtubeVideoSrc);

  const mqTab = window.matchMedia('(min-width: 1024px)');
  const mq3 = window.matchMedia('(max-width: 769px)');

  $('#hp-landing-video').addClass('is-playing');
  $('.scrollDownArrow').css('opacity', '1');
  $('.hp-main').css('opacity', '1');
  $('.arrowLines').css('width', '13px');

  setTimeout(function () {
    $('.arrowLines1')
      .css('transform', 'rotate(-45deg)')
      .css('margin-left', '-2px');
    $('.arrowLines2')
      .css('transform', 'rotate(45deg)')
      .css('margin-right', '-2px');
  }, 600);

  // SCROLL DOWN ARROW HOVER ANIMATION
  var hoverCount = 0;
  $('.scrollDownArrow').hover(function () {
    hoverCount++;
    //even odd hover detect
    var isEven = function (someNumber) {
      return someNumber % 2 === 0 ? true : false;
    };
    // on even hover do this
    if (isEven(hoverCount) === true) {
      // animate back to standard arrow
      $('.arrowLines').css('width', '13px');
      $('.downArrowLine').removeClass('animated');
      $('.arrowLines1')
        .css('transform', 'rotate(-45deg)')
        .css('margin-left', '-2px');
      $('.arrowLines2')
        .css('transform', 'rotate(45deg)')
        .css('margin-right', '-2px');
    }
    // on odd hover do this
    else if (isEven(hoverCount) === false) {
      // animated scroll down
      $('.arrowLines').css('width', '15px');
      $('.downArrowLine').addClass('animated');
      $('.arrowLines1')
        .css('transform', 'rotate(-225deg)')
        .css('margin-left', '-2.5px');
      $('.arrowLines2')
        .css('transform', 'rotate(225deg)')
        .css('margin-right', '-2.5px');
    }
  });

  $('.scrollDownArrow').click(function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: $('.hp-landText').height() }, 'slow');
  });

  //DEVICE ICONS
  $('.ok-ic').hover(function () {
    let device = $(this).data('device');

    $(this).toggleClass('ic-hover');
  });

  //BRAND WALL
  $('.marquee').marquee({
    //speed in milliseconds of the marquee
    duration: 60000,
    //gap in pixels between the tickers
    gap: 0,
    //time in milliseconds before the marquee will start animating
    delayBeforeStart: 0,
    //'left' or 'right'
    direction: 'left',
    //true or false - should the marquee be duplicated to show an effect of continues flow
    duplicated: true,
    //true or false - should the marquee be shown right away
    startVisible: true,
  });

  //Email form on mobile
  $('.joinText').on('click', function (e) {
    if (mq3.matches) {
      $('.joinText').css('top', '5%');
      $('#email_signup').css('display', 'block');
    }
  });

  window.onscroll = function (e) {
    //BACK TO TOP
    if ($(window).scrollTop() > $(window).height() * 1) {
      $('#backToTop').css('display', 'block').css('opacity', '0.5');
    } else {
      $('#backToTop').css('opacity', '0').css('display', 'none');
    }
  };

  $('#backToTop').each(function () {
    $(this).click(function (e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 'slow');
    });
  });

  $('.color').each(function () {
    $(this).click(function (e) {
      e.preventDefault();
      let color = $(this).data('color');
      let num = $(this).data('num');
      $('.color').removeClass('selected');
      $(this).addClass('selected');

      $('.color-name').text(color);
      if (mq3.matches) {
        let url = color.replace(/\s/g, '-') + '.jpg';
        $('#color-img-mob').attr(
          'src',
          'https://d35408cyocioye.cloudfront.net/new3/vail/' + url
        );
      } else {
        let url = color.replace(/\s/g, '-') + '@.jpg';
        $('#color-img').attr(
          'src',
          'https://d35408cyocioye.cloudfront.net/new3/vail/' + url
        );
      }
      // $('.hp-ai').removeClass('img-01 img-02 img-03 img-04 img-05 img-06');
      // $('.hp-ai').addClass('img-0' + num);
      // $('.hp-ai').css('background-image', 'url(https://d35408cyocioye.cloudfront.net/new3/vail/' + url + ')');
    });
  });
});
